module.exports = "<a :class=\"cls\" :href=\"link || ''\" @click.prevent></a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/social-media/components/social-media-item/template.html
// module id = TVTx
// module chunks = 0